import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=3c856fa0&scoped=true"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=3c856fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c856fa0",
  null
  
)

export default component.exports